<template>
  <div class="admin-login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="logo">
          <el-icon><Setting /></el-icon>
        </div>
        <h1 class="title">系统管理后台</h1>
        <p class="subtitle">安全设备管理系统</p>
      </div>

      <div class="login-form">
        <el-form 
          :model="loginForm" 
          :rules="loginRules" 
          ref="loginForm"
          @submit.native.prevent="handleLogin"
        >
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入管理员账号"
              size="large"
              clearable
            >
              <template #prefix>
                <el-icon><User /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              size="large"
              show-password
              clearable
              @keyup.enter.native="handleLogin"
            >
              <template #prefix>
                <el-icon><Lock /></el-icon>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              size="large"
              :loading="loginLoading"
              @click="handleLogin"
              class="login-btn"
            >
              {{ loginLoading ? '登录中...' : '登录' }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="login-features">
        <div class="feature-title">管理功能</div>
        <div class="feature-list">
          <div class="feature-item">
            <el-icon><House /></el-icon>
            <span>家庭管理与数据统计</span>
          </div>
          <div class="feature-item">
            <el-icon><Mobile /></el-icon>
            <span>设备库存管理</span>
          </div>
          <div class="feature-item">
            <el-icon><DataAnalysis /></el-icon>
            <span>系统数据分析</span>
          </div>
        </div>
      </div>

      <div class="login-footer">
        <p class="tips">仅限系统管理员使用</p>
        <p class="default-account">默认账号：admin / admin123</p>
        <div class="user-login-link">
          <a href="/login" target="_blank" class="link-button">
            <el-icon><House /></el-icon>
            <span>家庭用户登录</span>
            <el-icon><ArrowRight /></el-icon>
          </a>
        </div>
      </div>
    </div>

    <!-- 背景装饰 -->
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>
  </div>
</template>

<script>
import { User, Lock, House, Mobile, DataAnalysis, Setting, ArrowRight, CircleClose, View, Hide } from '@element-plus/icons-vue'

export default {
  name: 'AdminLogin',
  components: {
    User, Lock, House, Mobile, DataAnalysis, Setting, ArrowRight, CircleClose, View, Hide
  },
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
      },
      loginLoading: false
    }
  },
  methods: {
    async handleLogin() {
      try {
        const valid = await this.$refs.loginForm.validate()
        if (!valid) return

        this.loginLoading = true

        // 调用管理员登录API
        const response = await this.$http.post('/admin/api/login', this.loginForm)
        
        if (response.data.success) {
          const adminData = response.data.data
          
          // 存储管理员信息
          localStorage.setItem('adminUser', JSON.stringify(adminData))
          localStorage.setItem('userRole', 'admin')
          
          this.$message.success('登录成功')
          
          // 跳转到管理员首页
          this.$router.push('/admin/dashboard')
        } else {
          this.$message.error(response.data.message || '登录失败')
        }

      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error(error.response?.data?.message || '登录失败，请重试')
      } finally {
        this.loginLoading = false
      }
    }
  }
}
</script>

<style scoped>
.admin-login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 40px;
  width: 450px;
  max-width: 90vw;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 10;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  font-size: 60px;
  color: #667eea;
  margin-bottom: 20px;
}

.logo .el-icon {
  font-size: 60px;
}

/* 确保输入框图标正确显示 */
.login-form .el-input .el-icon {
  color: #a8abb2;
}

.login-form .el-input:hover .el-icon {
  color: #909399;
}

.login-form .el-input.is-focus .el-icon {
  color: #667eea;
}

/* 确保前缀图标正确显示 */
.login-form .el-input__prefix {
  display: flex;
  align-items: center;
}

.login-form .el-input__prefix .el-icon {
  color: #667eea !important;
  font-size: 16px;
}

/* 确保后缀图标（清除、显示密码）正确显示 */
.login-form .el-input__suffix {
  display: flex;
  align-items: center;
}

.login-form .el-input__suffix .el-icon {
  cursor: pointer;
  font-size: 14px;
}

.login-form .el-input__clear,
.login-form .el-input__password {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0 0 10px 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.subtitle {
  color: #666;
  font-size: 16px;
  margin: 0;
}

.login-form {
  margin-bottom: 30px;
}

.login-btn {
  width: 100%;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 8px;
}

.login-btn:hover {
  background: linear-gradient(135deg, #5a6fd8, #6a42a0);
}

.login-features {
  margin-bottom: 30px;
  padding: 20px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 12px;
}

.feature-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #555;
  font-size: 14px;
}

.feature-item .el-icon {
  color: #667eea;
  font-size: 16px;
  width: 20px;
}

.login-footer {
  text-align: center;
}

.tips {
  color: #999;
  font-size: 14px;
  margin: 0 0 10px 0;
}

.default-account {
  color: #667eea;
  font-size: 13px;
  margin: 0 0 20px 0;
  padding: 8px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 6px;
}

.user-login-link {
  margin-top: 15px;
}

.link-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(79, 172, 254, 0.3);
}

.link-button:hover {
  background: linear-gradient(135deg, #4098fe 0%, #00d4fe 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 172, 254, 0.4);
  color: white;
  text-decoration: none;
}

.link-button .el-icon:first-child {
  font-size: 16px;
}

.link-button .el-icon:last-child {
  font-size: 12px;
  margin-left: 4px;
}

/* 背景装饰 */
.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.circle-1 {
  width: 200px;
  height: 200px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.circle-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.circle-3 {
  width: 100px;
  height: 100px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-card {
    padding: 30px 20px;
    width: 100%;
    margin: 20px;
  }
  
  .title {
    font-size: 24px;
  }
  
  .feature-list {
    gap: 8px;
  }
  
  .feature-item {
    font-size: 13px;
  }
  
  .link-button {
    padding: 10px 16px;
    font-size: 13px;
  }
  
  .link-button .el-icon:first-child {
    font-size: 14px;
  }
}
</style>